import React from "react";

import Profile from "./UserProfile";
import Interview from "./Interviewer"
import Navbar from "./NavBar"
import { Col, Container, Row } from "react-bootstrap";

const ProfileInterview = () => {
    return (
        <>
            <Navbar />
            <div className="bgColor">
                {/* <Container fluid="sm"> */}
                {/* <Row className="py-5"> */}
                <Row className="py-4">
                    <Col sm={12} md={4}>
                        <Profile />
                    </Col>
                    <Col sm={12} md={8}>
                        <Interview />
                    </Col>
                </Row>
                {/* </Row> */}
                {/* </Container> */}
            </div>
        </>

    )
}

export default ProfileInterview;